import type React from "react";

interface ChartIconProps {
  className?: string;
  isSelected?: boolean;
}

export const ChartFormatIcon: React.FC<ChartIconProps> = ({ className, isSelected }) => (
  <svg
    style={{ width: "100%", height: "100%" }}
    width="240"
    height="98"
    viewBox="0 0 240 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_696_4498)">
      <mask
        id="mask0_696_4498"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="238"
        height="94"
      >
        <rect width="238" height="93" transform="translate(2 2.87207)" fill="url(#paint0_linear_696_4498)" />
      </mask>
      <g mask="url(#mask0_696_4498)">
        <path
          opacity="0.1"
          d="M240 2.87207C201.333 5.39032 198.938 65.6788 160.667 72.6221C129.107 78.3477 113.127 45.8465 81.3333 49.3721C46.8488 53.1961 35.8136 87.0635 2 95.8721H240V2.87207Z"
          fill={isSelected ? "#7F56D9" : "#535862"}
        />
      </g>
      <path
        d="M2 95.8721C35.8136 87.0635 46.8488 53.1961 81.3333 49.3721C113.127 45.8465 129.107 78.3477 160.667 72.6221C198.938 65.6788 201.333 5.39032 240 2.87207"
        stroke={isSelected ? "#7F56D9" : "#A4A7AE"}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.2">
        <rect
          x="187.781"
          y="30.2158"
          width="17.25"
          height="17.25"
          rx="8.625"
          stroke={isSelected ? "#7F56D9" : "#A4A7AE"}
          strokeWidth="2"
        />
      </g>
      <rect x="192.156" y="34.5908" width="8.5" height="8.5" rx="4.25" fill="white" />
      <rect
        x="192.156"
        y="34.5908"
        width="8.5"
        height="8.5"
        rx="4.25"
        stroke={isSelected ? "#7F56D9" : "#A4A7AE"}
        strokeWidth="2"
      />
    </g>
    <path
      d="M10 1H230C235.247 1 239.5 5.25329 239.5 10.5V87.5C239.5 92.7467 235.247 97 230 97H10C4.7533 97 0.5 92.7467 0.5 87.5V10.5C0.500001 5.2533 4.7533 1 10 1Z"
      stroke={isSelected ? "#7F56D9" : "#D5D7DA"}
    />
    <defs>
      <linearGradient id="paint0_linear_696_4498" x1="119" y1="0" x2="119" y2="93" gradientUnits="userSpaceOnUse">
        <stop />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_696_4498">
        <path
          d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5H230C235.523 0.5 240 4.97715 240 10.5V87.5C240 93.0229 235.523 97.5 230 97.5H10C4.47716 97.5 0 93.0229 0 87.5V10.5Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
